import styled from 'styled-components/macro'

export const Title = styled.p`
  color: ${(props) => props.color};
  font-family: IBMPlexSans-Extrabold;
  font-size: 16px;
`

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  grid-gap: 8px;
  text-transform: uppercase;
`
